export default "__VITE_ASSET__Dv8t9wrb__"